import { DELIVERY_TYPE, DINEIN_TYPE } from '../../../webStorage/keys/sessionKeys';
export const findFilterTypes = (arr) => {
  if (!Array.isArray(arr)) return null;
  const uniqueTypes = {};
  arr.forEach((item) => {
    if (uniqueTypes[item['filter-type']]) uniqueTypes[item['filter-type']].push(item);
    else uniqueTypes[item['filter-type']] = [item];
  });
  return uniqueTypes;
};

export const removeOtherKeysFromArray = (arr, vegCheck) => {
  if (!Array.isArray(arr)) return vegCheck ? [['veg'], null, null] : [];
  let isAvailableSelected = false;
  const preference = arr.filter((item) => {
    if (item.id == 'available') isAvailableSelected = item.selected;
    return item.selected && item['filter-type'] == 'preference' && item.id != 'available';
  });
  const cleanedPreference = preference.map((item) => item.id.toLowerCase());
  if (vegCheck) cleanedPreference.push('veg');
  const price = arr.find((item) => item.selected && item['filter-type'] == 'price');
  return [cleanedPreference, Number(price?.value), isAvailableSelected];
};

export const compareMenuWithAppliedFilter = (menuArray, filterArray, orderType, vegCheck) => {
  if (!filterArray.length && !vegCheck) return menuArray;
  const anyChange = filterArray.some((elem) => elem.selected);
  if (!anyChange && !vegCheck) return menuArray;
  try {
    const [preferenceArray, priceLimit, isAvailable] = removeOtherKeysFromArray(
      filterArray,
      vegCheck
    );
   
    return preferenceArray?.length || priceLimit || isAvailable
      ? menuArray.filter((innerItem) => {
          let availablityFlag = true;
          let priceFlag = true;
          let preferenceFlag = true;
          if (isAvailable) availablityFlag = innerItem.is_available > 0;
          if (preferenceArray.length) {
            const availableFilterOptions = innerItem?.filters
              ?.split('|')
              .filter(Boolean)
              .map((item) => item?.toLowerCase());
            const checkIfAvailable =
              availableFilterOptions &&
              preferenceArray.some((elem) => availableFilterOptions?.includes(elem));
            preferenceFlag = checkIfAvailable;
          }
          const offeringPrice =
            (orderType == DINEIN_TYPE && innerItem.price) ||
            (orderType == DELIVERY_TYPE && innerItem.delivery_price) ||
            innerItem.takeaway_price;
          if (priceLimit) priceFlag = offeringPrice < priceLimit;
          return availablityFlag && preferenceFlag && priceFlag;
        })
      : menuArray;
  } catch (error) {
    return menuArray;
  }
};
